import EmojiPickerButton from './EmojiPickerButton';

export default EmojiPickerButton;
